<template>
  <router-view></router-view>
</template>

<script>
import utilsService from '@/api/utilsService';

export default {
  mounted() {
    this._handleSessionSync = () => {
      const result = utilsService.syncSessionFromShared();
      if (result === 'cleared' && this.$route.name !== 'login') {
        this.$router.replace({ name: 'login' }).catch(() => {});
      } else if (result === 'adopted') {
        utilsService.getMe();
        if (this.$route.name === 'login') {
          this.$router.replace({ name: 'dashboard' }).catch(() => {});
        }
      }
    };

    // Sincronizar ID local si ya hay sesión activa al cargar la app
    if (localStorage.getItem('user-session')) {
      utilsService.getMe();
    }

    this._onVisibility = () => {
      if (document.visibilityState === 'visible') this._handleSessionSync();
    };

    window.addEventListener('focus', this._handleSessionSync);
    document.addEventListener('visibilitychange', this._onVisibility);

    if ('cookieStore' in window) {
      this._onCookieChange = () => this._handleSessionSync();
      window.cookieStore.addEventListener('change', this._onCookieChange);
    } else {
      this._sessionInterval = setInterval(() => {
        if (document.visibilityState === 'visible') this._handleSessionSync();
      }, 2000);
    }
  },
  beforeDestroy() {
    window.removeEventListener('focus', this._handleSessionSync);
    document.removeEventListener('visibilitychange', this._onVisibility);
    if (this._onCookieChange && 'cookieStore' in window) {
      window.cookieStore.removeEventListener('change', this._onCookieChange);
    }
    if (this._sessionInterval) clearInterval(this._sessionInterval);
  },
}
</script>
